<div
  class="maincontainer"
  >
  <section class="contentcontainer">
    <div class="row">
      <div class="col-12">
        <div class="page-header">
          <div class="header-title">
            <h1 class="title">MAIN LIST</h1>
            <span>{{ subtitle }}</span>
          </div>

          <div
            class="header-action"
            style="margin-left: auto"
            >
            <aecom-button innerClass="btn solid lg blue" (click)="download()">
              Download Log
            </aecom-button>
          </div>

          @if (showCreateBtn) {
            <div
              class="header-action"
              style="margin-left: 20px"
              >
              <aecom-button
                data-cy="new"
                innerClass="btn solid lg blue"
                (click)="createCorr()"
                >
                Create New
              </aecom-button>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="row" [ngClass]="{ tablestyle: fixedheadercss }">
      <div class="col-12">
        <aecom-table
          [ngValue]="tableData"
          (ngValueChange)="tableRows = $event"
          [theme]="'light'"
          innerClass="list cus list-view-page"
          id="excel-table"
          >
          <div class="filters-section">
            <div class="d-flex">
              <div class="pr-15" style="width: 391px">
                <aecom-textbox
                  [theme]="'light'"
                  [(ngValue)]="searchText"
                  name="table-search"
                  placeholder="Search"
                  iconLeft="icon-basic_magnifier"
                  (keyupEnter)="filterData()"
                ></aecom-textbox>
              </div>
              <div class="pr-15">
                @if (showOrgDD) {
                  <aecom-dropdown
                    [theme]="'light'"
                    [data]="fromToFilter"
                    [placeholder]="'All Organization'"
                    [autocomplete]="true"
                    [(selectedId)]="fromToFilterId"
                    (ngValueChange)="changeFromToFilter($event)"
                  ></aecom-dropdown>
                }
              </div>
            </div>

          </div>

          <thead>
            <tr class="listRFI_tr">
              <th class="sort" id="CorrNumber" [ngStyle]="{'width.px':widthId}">Correspondence #</th>
              <th class="sort" id="OrganizationRef">Organization Ref.#</th>
              <th class="sort" id="Subject" style="width: 20%;">Subject</th>
              <th class="sort" id="ReferenceNumber">Reference</th>
              <th class="sort" id="FromOrg">From</th>
              <th class="sort" id="ToOrg">To</th>
              <th class="sort" id="LetterDateSort" [ngStyle]="{'width.px':widthDate}">Letter Date</th>
              <!-- <th class="sort" id="ReceivedDateSort">Received Date</th>
              <th class="sort" id="DueDateSort">Due Date</th> -->
              <th class="sort" id="KeyWords" style="width: 15%;">Key Words</th>
              <th class="sort" id="Status">Status</th>
              <th class="sort no-print" id="response" [ngStyle]="{'width.px':widthAction}">Response</th>
            </tr>
          </thead>
          <tbody data-cy="tbody">
            @for (row of tableRows; track row) {
              @if (!row.IsHidden) {
                <tr>
                  <td [ngStyle]="{'width.px':widthId}">{{ row.CorrNumber }}</td>
                  <td>{{ row.OrganizationRef }}</td>
                  <td style="width: 20%;">{{ row.Subject }}</td>
                  <td>{{ row.ReferenceNumber }}</td>
                  <td>{{ row.FromOrg }}<div>{{ row.From}}</div></td>
                  <td>{{ row.ToOrg }}<div>{{ row.To }}</div></td>
                  <td [ngStyle]="{'width.px':widthDate}">{{ row.LetterDate }}</td>
                  <!-- <td>{{ row.ReceivedDate }}</td>
                  <td>{{ row.DueDate }}</td> -->
                  <!-- <td>{{ row.KeyWords | titlecase }}</td> -->
                  <td style="width: 15%;">
                    <div style="display: flex; flex-wrap: wrap">
                      @for (tag of row.KeyWords; track tag) {
                        <div style="position: relative; margin-right: 6px; margin-bottom: 6px;">
                          <div class="tag">
                            {{tag | titlecase}}
                          </div>
                        </div>
                      }
                    </div>
                  </td>
                  <td>
                    <div>
                      <i [class]="row.StatusIcon"></i>
                      <span data-cy="status">{{ row.StatusText }}</span>
                    </div>
                  </td>
                  <td class="no-print" [ngStyle]="{'width.px':widthAction}">
                    @if (!row.HideBtn) {
                      <aecom-button
                        data-cy="btn"
                        [innerClass]="row.BtnClass"
                        (click)="goTo(row.BtnUrl)"
                        >
                        {{ row.BtnText }}
                      </aecom-button>
                    }
                  </td>
                </tr>
              }
            }
          </tbody>
        </aecom-table>
      </div>
    </div>
  </section>
</div>
